export const HOMEPAGE = "/";
export const OUR_SERVICES = "/our-services";
export const CHAT_BOOKING = "/chat-booking";
export const TECHNOLOGIES = "/technologies";
export const MEET_OUR_TEAM = "/our-team";
export const LOGIN = "/login";
export const REGISTRATION = "/registration";
export const VERIFY_OTP = "/verify-otp";
export const LOGOUT = "/logout";
export const JOBS = "/jobs";
export const CREATE_JOB = "/jobs/create";
export const EDIT_JOB = "/jobs/edit";
export const APPLICATION_SEARCH = "/applications";
export const APPLICATION_LIST = "/applications";
export const APPLICATION_DETAIL = "/applications/detail";
export const SET_PASSWORD = "/reset-password";
export const EMPLOYEE_PORTAL = "/employee";
export const CREATE_EMPLOYEE = "/employee/create";
export const EDIT_EMPLOYEE = "/employee/edit";
export const SERVICES = "/services";
